module.exports = __webpack_public_path__ + "static/media/blog14.21f45908.jpg";